import { useContext, useEffect, useState } from 'react';

import EnrollmentApi from '../../../api/enrollmentApi';
import StatApi from '../../../api/statApi';
import SkillData from '../../../types/skillData';
import { BaseStatData } from '../../../types/statData';
import { AuthContext } from '../../../utils/AuthProvider';
import MediaMethods from '../../atoms/mediaDataCollector/MediaMethods';

interface CompletedContentProps {
  skill: SkillData;
}

function CompletedContent({ skill }: CompletedContentProps) {
  const [timeSpent, setTimeSpent] = useState<number>();
  const [completed, setCompleted] = useState<BaseStatData>();
  const { user } = useContext(AuthContext)!;

  useEffect(() => {
    async function getData() {
      const enrolment = await EnrollmentApi.getEnrollmentByUserAndSkill(user!, skill);
      const skillCompleted = await StatApi.getStatWithTargetIdAndUserId(skill.id, user!.uid);
      const timeSpent = (skillCompleted!.created.getTime() - enrolment!.date) / 1000;

      setCompleted(skillCompleted);
      setTimeSpent(timeSpent);
    }

    getData();
  }, [user, skill]);

  return (
    <div className="default-content">
      <h3 className="skill-heading skill-name">{skill.name}</h3>
      <div className="main">
        <p>Completed on: {completed?.created.toDateString()}</p>
        <p>Completed in: {MediaMethods.convertSecondsToTime(timeSpent!, true)}</p>
      </div>
      <div className="side"></div>
      <div className="tags-container">
        <div className="tag">
          <p>Test tag</p>
        </div>
        <div className="tag">Some other tag</div>
      </div>
    </div>
  );
}

export default CompletedContent;
